import type { JSX, Ref } from 'react'
import type { IconNames } from 'atoms/Icon'
import type { BRAND_PADDINGS } from 'vars/index'

import { useCallback, useState } from 'react'
import { InlineBrandButton } from 'atoms/Button/Templates'
import { IconSizes } from 'atoms/Icon'
import { ImagePoster } from 'atoms/ImagePoster'
import { BrandAlignItems } from './BrandContainer.h'
import { BrandContainerSC } from './BrandContainer.styled'

export interface IBrandContainer {
  ref?: Ref<HTMLDivElement>
  alignItem?: BrandAlignItems
  logoUrl?: string
  logoHeight?: string
  logoMinHeight?: string
  logoWidth?: string
  paddings?: BRAND_PADDINGS
  icon?: IconNames
  iconSize?: IconSizes
  onClick?: () => void
  scaleLogo?: boolean
}

export function BrandContainer({
  ref,
  logoUrl,
  logoHeight,
  logoWidth,
  paddings,
  alignItem = BrandAlignItems.Center,
  icon,
  // iconSize = IconSizes.medium,
  onClick,
  scaleLogo,
  logoMinHeight,
}: IBrandContainer): JSX.Element {
  const [notError, setNotError] = useState(false)
  const handleError = useCallback(() => setNotError(true), [])

  return (
    <>
      {!notError && (logoUrl || icon) && (
        <BrandContainerSC
          logoHeight={logoHeight}
          logoUrl={logoUrl}
          logoWidth={logoWidth}
          alignItem={alignItem}
          paddings={paddings}
          ref={ref}
          scaleLogo={scaleLogo}
          logoMinHeight={logoMinHeight}
        >
          {icon && <InlineBrandButton icon={icon} onClick={onClick} />}
          {logoUrl && (
            <ImagePoster
              posterUrl={logoUrl}
              handleError={handleError}
              lazy={false}
            />
          )}
        </BrandContainerSC>
      )}
    </>
  )
}
